import React, { ComponentProps, FunctionComponent } from "react";

const LineFunnelIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 29",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M17.3335 29H22.667C23.4024 29 24.0004 28.4088 24.0004 27.6818C24.0004 26.9548 23.4041 26.3636 22.667 26.3636H17.3335C16.5981 26.3636 16.0001 26.9548 16.0001 27.6818C16.0001 28.4088 16.5981 29 17.3335 29ZM14.0001 22.4091H26C26.7354 22.4091 27.3334 21.8196 27.3334 21.0909C27.3334 20.3639 26.7354 19.7727 26 19.7727H14.0001C13.2648 19.7727 12.6668 20.3622 12.6668 21.0909C12.6668 21.8179 13.2648 22.4091 14.0001 22.4091ZM9.33337 15.8182H30.6668C31.4021 15.8182 32.0002 15.227 32.0002 14.5C32.0002 13.773 31.4038 13.1818 30.6668 13.1818H9.33337C8.59804 13.1818 8.00002 13.773 8.00002 14.5C8.00002 15.227 8.598 15.8182 9.33337 15.8182ZM5.33336 9.22727H34.6667C35.4021 9.22727 36.0001 8.6361 36.0001 7.90909C36.0001 7.18213 35.4038 6.59091 34.6667 6.59091H5.33336C4.59803 6.59091 4.00001 7.18209 4.00001 7.90909C4.00001 8.63605 4.59799 9.22727 5.33336 9.22727ZM1.33335 2.63636H38.6667C39.402 2.63636 40 2.04684 40 1.31818C40 0.591219 39.4037 0 38.6667 0H1.33335C0.598022 0 0 0.589523 0 1.31818C0 2.04514 0.597979 2.63636 1.33335 2.63636Z",
    })
  );
};

const ForwardRef = React.forwardRef(LineFunnelIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
